import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { resolveSignageSessionOrganizationId } from "../api/salesOrderApi";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { showError, showSuccess } from "toast/toast";
import Personal_Info from "assets/images/Agents/Personal_Info.png"
import shield from "assets/images/Agents/shield.png"
import Profile from "assets/images/Agents/Profile.png"
import Permission_Assignment from "assets/images/Agents/Permission_Assignment.png"
import imageCustomSquare from "assets/images/imagecustomrounded.png";
import { IconHeading } from "components/Iconsborders";
import Select, { SingleValue, components } from "react-select";
import { AsyncPaginate, LoadOptions } from "react-select-async-paginate";
import { Role, RoleAssignment } from "types"
import {
    firstNameValidation,
    lastNameValidation,
    emailValidation,
    phoneValidation,
    // passwordValidation,
    statusValidation,
    assignedOfficesValidation,
    permissionsValidation,
} from "validationSchemas/common";
import { getCloudFileById, fileToBase64 } from "components/Imageshelper";
import { getAuthCookie } from "../utils/authCookies";
type Office = {
    _id: string;
    officeName: string;
    officeType: string;
    officeAddress?: Array<{
        _id: string;
        label?: string;
        addressLine1?: string;
        addressLine2?: string;
        city?: string;
        state?: string;
        country?: string;
        zip?: string;
        phone?: string;
    }>;
};

type TeamMemberAPI = {
    id: string;
    firstName: string;
    lastName: string;
    jobTitle: string;
    jobTitleId?: string;
    job_title_id?: string;
    customRole?: string;
    phone1: string;
    phone2?: string;
    email: string;
    accessLevel: string[];     // ["all"] or any of ["view","edit","delete"]
    status: string;            // "Active" | "Inactive"
    profilePic?: string | null;
    offices?: Office[];
};

type Option = {
    value: string;
    label: string;
    email?: string;
    office_count?: number;
    profilePicURL?: string;
};
type JobTitleOption = { value: string; label: string; id?: string };

type BrokerageTeammemberFormValues = {
    firstName: string;
    lastName: string;
    phone: string;
    secondaryPhone: string;
    email: string;
    password: string;
    jobTitle: string;
    jobTitleId: string;
    customRole: string;
    assignedOffices: string[];
    brokeragePermissions: string;
    statuss: string;
    image: File | null;
    profilePic: string | null;
};

const JOB_TITLE_CUSTOM = "Custom";
const noAutoSuggestInputProps = {
    autoComplete: "new-password",
    spellCheck: false,
    autoCorrect: "off",
    autoCapitalize: "off",
};

const STATUS_OPTIONS: Option[] = [
    { value: "Active", label: "Active" },
    { value: "Inactive", label: "Inactive" },
];

const PERMISSION_LEVELS: Option[] = [
    { value: "all", label: "All" },
    { value: "view", label: "View" },
    { value: "edit", label: "Edit" },
    { value: "delete", label: "Delete" },
];

// Accordion layout from your mock
const PERM_GROUPS: { key: string; title: string; rows: string[] }[] = [
    { key: "agents", title: "Agents", rows: ["Agents"] },
    {
        key: "inventory",
        title: "Inventory",
        rows: ["Office Inventory", "Agent Inventory", "Office and Agent Inventory", "Brands and Categories"],
    },
    { key: "orders", title: "Orders", rows: ["Orders"] },
    { key: "jobs", title: "Jobs", rows: ["Installations", "Removals"] },
    { key: "suppliers", title: "Suppliers", rows: ["Suppliers"] }, // special columns: Link/Unlink/All (UI only)
];

// 🔧 Keys and labels
type CrudKey = "create" | "view" | "edit" | "delete" | "all";
type SupplierKey = "link" | "unlink" | "all";

const CRUD_KEYS = ["create", "view", "edit", "delete", "all"] as const;
const SUPPLIER_KEYS = ["link", "unlink", "all"] as const;

const CRUD_LABELS: Record<CrudKey, string> = {
    create: "Create", view: "View", edit: "Edit", delete: "Delete", all: "All",
};
const SUPPLIER_LABELS: Record<SupplierKey, string> = {
    link: "Link", unlink: "Unlink", all: "All",
};

// 🔧 Make row values optional booleans for CRUD keys
type PermStateRow = Partial<Record<CrudKey, boolean>>;
type PermState = Record<string, PermStateRow>;

const cellCenter: React.CSSProperties = { textAlign: "center", verticalAlign: "middle" };

/** Hide arrow when disabled */
const DropdownIndicator = (props: any) => {
    if (props.selectProps.isDisabled) return null;
    return (
        <components.DropdownIndicator {...props}>
            <i className="ri-arrow-down-s-line fs-5" style={{ color: "#6c757d" }} />
        </components.DropdownIndicator>
    );
};

const customSelectStyles = {
    /* hide all indicators when disabled */
    indicatorsContainer: (provided: any, state: any) => ({
        ...provided,
        display: state.isDisabled ? "none" : "flex",
    }),
    dropdownIndicator: (provided: any, state: any) => ({
        ...provided,
        display: state.isDisabled ? "none" : "flex",
    }),
    indicatorSeparator: () => ({ display: "none" }),

    /* keep bg and cursor right; do NOT fade */
    control: (provided: any, state: any) => ({
        ...provided,
        backgroundColor: state.isDisabled ? "#f2f2f2" : provided.backgroundColor,
        cursor: state.isDisabled ? "not-allowed" : "pointer",
        opacity: 1,
    }),

    /* ——— make text BLACK when disabled ——— */
    singleValue: (provided: any, state: any) => ({
        ...provided,
        color: state.isDisabled ? "#000" : provided.color,
    }),
    valueContainer: (provided: any, state: any) => ({
        ...provided,
        color: state.isDisabled ? "#000" : provided.color,
    }),
    input: (provided: any, state: any) => ({
        ...provided,
        color: state.isDisabled ? "#000" : provided.color,
        WebkitTextFillColor: state.isDisabled ? "#000" : undefined, // Safari
    }),
    placeholder: (provided: any, state: any) => ({
        ...provided,
        /* if field has no value, keep placeholder readable too */
        color: state.isDisabled ? "#000" : provided.color,
    }),

    /* if you ever use isMulti, keep chips readable */
    multiValue: (p: any, s: any) => ({
        ...p,
        backgroundColor: s.isDisabled ? "#e5e7eb" : p.backgroundColor,
    }),
    multiValueLabel: (p: any, s: any) => ({
        ...p,
        color: s.isDisabled ? "#000" : p.color,
    }),
    multiValueRemove: (p: any, s: any) => ({
        ...p,
        display: s.isDisabled ? "none" : p.display,
    }),
};

const brokerageSelectStylesDesktop = {
    ...customSelectStyles,
    menu: (base: any) => ({
        ...base,
        backgroundColor: "#ffffff",
        border: "1px solid #e2e8f0",
        borderRadius: 8,
        boxShadow: "0 10px 24px rgba(15,23,42,0.08)",
        overflow: "hidden",
        zIndex: 9999,
    }),
    menuList: (base: any) => ({
        ...base,
        paddingTop: 0,
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        backgroundColor: "#ffffff",
        maxHeight: 340,
    }),
    option: (base: any, state: any) => ({
        ...base,
        backgroundColor: state.isSelected ? "#f8fafc" : "#ffffff",
        color: "#0f172a",
        padding: "12px 16px",
        borderBottom: "1px solid #f1f5f9",
        borderRadius: 0,
        marginBottom: 0,
        cursor: "pointer",
        ":active": {
            backgroundColor: "#f8fafc",
        },
        ":hover": {
            backgroundColor: "#f8fafc",
        },
    }),
};

const brokerageSelectStylesMobile = {
    ...brokerageSelectStylesDesktop,
    menuList: (base: any) => ({
        ...base,
        paddingTop: 10,
        paddingBottom: 10,
        paddingLeft: 10,
        paddingRight: 10,
        backgroundColor: "#f8fafc",
        maxHeight: 340,
    }),
    option: (base: any, state: any) => ({
        ...base,
        backgroundColor: state.isSelected ? "#eef2ff" : "#f8fafc",
        color: "#0f172a",
        padding: "0",
        borderBottom: "0",
        borderRadius: 14,
        marginBottom: 10,
        cursor: "pointer",
        ":active": {
            backgroundColor: "#eef2ff",
        },
        ":hover": {
            backgroundColor: "#eef2ff",
        },
    }),
};
const toUrlString = (res: unknown): string | null => {
    if (!res) return null;
    if (typeof res === "string") return res;
    const r = res as any;
    const u = r?.url ?? r?.signedUrl ?? r?.data?.url;
    return typeof u === "string" ? u : null;
};

const renderBrokerageOptionLabelDesktop = (
    option: Option,
    context: { context: "menu" | "value" }
) => {
    if (context.context !== "menu") return option.label;
    const officeCount =
        Number.isFinite(Number(option.office_count)) && Number(option.office_count) >= 0
            ? Math.floor(Number(option.office_count))
            : 0;
    const officeText = `${officeCount} office${officeCount === 1 ? "" : "s"}`;
    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                fontFamily: "Roboto, sans-serif",
            }}
        >
            <img
                src={option.profilePicURL || imageCustomSquare}
                alt=""
                style={{ width: 72, height: 56, borderRadius: 8, objectFit: "contain", flexShrink: 0 }}
                onError={(e) => {
                    e.currentTarget.src = imageCustomSquare;
                }}
            />
            <div style={{ minWidth: 0 }}>
                <div
                    style={{
                        fontSize: 15,
                        fontWeight: 600,
                        color: "#0f1726",
                        lineHeight: "20px",
                        marginBottom: 6,
                    }}
                >
                    {option.label}
                </div>
                <div style={{ fontSize: 14, fontWeight: 600, color: "#0f172a", lineHeight: "20px" }}>
                    {officeText}
                </div>
                <div
                style={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: "#111827",
                    lineHeight: "20px",
                }}
                >
                    {String(option.email || "").trim() || "-"}
                </div>
            </div>
        </div>
    );
};

const renderBrokerageOptionLabelMobile = (
    option: Option,
    context: { context: "menu" | "value" }
) => {
    if (context.context !== "menu") return option.label;
    const officeCount =
        Number.isFinite(Number(option.office_count)) && Number(option.office_count) >= 0
            ? Math.floor(Number(option.office_count))
            : 0;
    const officeText = `${officeCount} office${officeCount === 1 ? "" : "s"}`;
    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 10,
                padding: "12px",
                border: "1px solid #e2e8f0",
                borderRadius: 14,
                background: "#ffffff",
                fontFamily: "Roboto, sans-serif",
            }}
        >
            <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <img
                    src={option.profilePicURL || imageCustomSquare}
                    alt=""
                    style={{ width: 72, height: 56, borderRadius: 8, objectFit: "contain", flexShrink: 0 }}
                    onError={(e) => {
                        e.currentTarget.src = imageCustomSquare;
                    }}
                />
            </div>
            <div style={{ minWidth: 0 }}>
                <div
                    style={{
                        fontSize: 15,
                        fontWeight: 600,
                        color: "#0f1726",
                        lineHeight: "20px",
                        marginBottom: 6,
                    }}
                >
                    {option.label}
                </div>
                <div style={{ fontSize: 14, fontWeight: 600, color: "#0f172a", lineHeight: "20px" }}>
                    {officeText}
                </div>
                <div
                    style={{
                        fontSize: 14,
                        fontWeight: 500,
                        color: "#111827",
                        lineHeight: "20px",
                    }}
                >
                    {String(option.email || "").trim() || "-"}
                </div>
            </div>
        </div>
    );
};

export type BrokerageTeammemberCreationVariant = "standalone" | "inline" | "modal";

export type BrokerageTeammemberCreatedResult = {
    id: string;
    membershipId?: string;
    globalUserId?: string;
    organizationId?: string;
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    brokerageFirmId: string;
    brokerageFirmName: string;
    offices: { _id: string; officeName: string }[];
    jobTitle?: string;
};

export type BrokerageTeammemberCreationComponentProps = {
    firmId?: string;
    teammemberId?: string;
    /** @deprecated Use variant="modal" instead */
    embedded?: boolean;
    /** standalone = full page; inline = project create panel; modal = brokerage teammembers popup */
    variant?: BrokerageTeammemberCreationVariant;
    onClose?: () => void;
    onSuccess?: (created?: BrokerageTeammemberCreatedResult) => void;
};

export default function BrokerageTeammemberCreationComponent({
    firmId: firmIdProp,
    teammemberId: teammemberIdProp,
    embedded = false,
    variant: variantProp,
    onClose,
    onSuccess,
}: BrokerageTeammemberCreationComponentProps = {}) {
    const variant: BrokerageTeammemberCreationVariant =
        variantProp ?? (embedded ? "modal" : "standalone");
    const { firmId: routeFirmId } = useParams<{ firmId: string }>();
    const { teammemberId: routeTeammemberId } = useParams<{ teammemberId: string }>();
    const effectiveFirmId = firmIdProp ?? routeFirmId;
    const effectiveTeammemberId = teammemberIdProp ?? routeTeammemberId;
    const isEdit = Boolean(effectiveTeammemberId);
    const navigate = useNavigate();
    const location = useLocation();
    const token = getAuthCookie("sessionToken") || "";
    const userId = getAuthCookie("userId") || "";
    const organizationId = getAuthCookie("organizationId") || "";
    const sessionLicenseType = String(getAuthCookie("licenseType") || "").trim().toUpperCase();
    const allowExistingMemberAccessConfirm =
        sessionLicenseType === "SIGNAGE_FIRM" || sessionLicenseType === "SIGNAGE_TEAM_MEMBER";
  const effectiveSignageOrgId = resolveSignageSessionOrganizationId() || organizationId || userId || "";
    const isSignageTeammember = location.pathname.includes("/signageteammember");
    const signageFirmId = effectiveSignageOrgId;

    const handleCancel = () => {
        if (onClose) {
            onClose();
            return;
        }
        navigate(-1);
    };

    const [loading, setLoading] = useState<boolean>(isEdit);
    const [formSubmitting, setFormSubmitting] = useState(false);
    const [memberAccessPrompt, setMemberAccessPrompt] = useState<{
        message: string;
        name: string;
        email: string;
    } | null>(null);
    const [memberAccessConfirmed, setMemberAccessConfirmed] = useState(false);
    const confirmMemberAccessRef = useRef(false);

    const [offices, setOffices] = useState<Office[]>([]);
    const [brokerageOptions, setBrokerageOptions] = useState<Option[]>([]);
    const [selectedBrokerageId, setSelectedBrokerageId] = useState<string>(effectiveFirmId || "");
    const [brokerageSearchInput, setBrokerageSearchInput] = useState("");
    const [brokerageSearch, setBrokerageSearch] = useState("");
    const [brokerageDropdownOpened, setBrokerageDropdownOpened] = useState(false);
    const [roles, setRoles] = useState<Role[]>([]);
    const [assignedRoles, setAssignedRoles] = useState<RoleAssignment[]>([]);
    const [roleAssignmentId, setRoleAssignmentId] = useState<string>(""); // Store the role assignment ID for updates
    const [member, setMember] = useState<TeamMemberAPI | null>(null);
    const [cloudFileId, setCloudFileId] = useState<string | null>(null);
    const [preview, setPreview] = useState<string | null>(null);
    const [serverImageSrc, setServerImageSrc] = useState<string | null>(null);

    const is24Hex = (s?: string | null) => !!s && /^[0-9a-f]{24}$/i.test(s);
    const normalizePath = (p: string) => p.replace(/\\/g, "/").replace(/^\/+/, "");
    const buildAbsoluteFromRelative = (p: string) => {
        const base = (process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "");
        return `${base}/${normalizePath(p)}`;
    };
    useEffect(() => {
        let active = true;
        (async () => {
            const val = member?.profilePic;
            if (!val) {
                if (active) setServerImageSrc(null);
                return;
            }
            if (/^https?:\/\//i.test(val)) {
                if (active) setServerImageSrc(val);
                return;
            }
            if (is24Hex(val)) {
                setCloudFileId(val);
                try {
                    const res = await getCloudFileById(val, token as string);
                    const u = toUrlString(res);
                    if (active) setServerImageSrc(u);
                } catch {
                    if (active) setServerImageSrc(null);
                }
                return;
            }
            if (active) setServerImageSrc(buildAbsoluteFromRelative(val));
        })();
        return () => {
            active = false;
        };
    }, [member?.profilePic, token]);
    // Permissions matrix state for accordion (UI only; we still send accessLevel array)
    const [permState, setPermState] = useState<PermState>({});
    const [showPassword, setShowPassword] = useState(false);

    // seed permission rows
    useEffect(() => {
        const initial: PermState = {};
        PERM_GROUPS.forEach(g =>
            g.rows.forEach(r => (initial[r] = { create: false, view: false, edit: false, delete: false, all: false }))
        );
        setPermState(initial);
    }, []);

    // fetch offices
  useEffect(() => {
        const brokerageIdForOffices = String(selectedBrokerageId || effectiveFirmId || "").trim();
        if (!brokerageIdForOffices) {
            setOffices([]);
            return;
        }
        (async () => {
            try {
                const res = await fetch(
                    `${process.env.REACT_APP_API_URL}/organizations/${brokerageIdForOffices}/offices`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                const data = await res.json();
                if (!res.ok || data?.error) throw new Error(data?.error || "Failed to fetch offices");
                setOffices(Array.isArray(data) ? (data as Office[]) : []);
            } catch (e: any) {
                showError(e.message || "Failed to fetch offices");
                setOffices([]);
            }
        })();
    }, [token, effectiveFirmId, selectedBrokerageId]);

    // top "Brokerage" section options
    useEffect(() => {
        if (!brokerageDropdownOpened) return;
        if (!organizationId || !token) {
            setBrokerageOptions([]);
            return;
        }
        const PAGE_SIZE = 20;
        (async () => {
            try {
                const q = brokerageSearch.trim();
                const params = new URLSearchParams({
                    licenseType: "BROKERAGE_FIRM",
                    query: q,
                    page: "1",
                    limit: String(PAGE_SIZE),
                });

                const res = await fetch(
                    `${process.env.REACT_APP_API_URL}/organizations/${organizationId}/memberships/select?${params}`,
                    {
                        headers: {
                            Accept: "application/json",
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );
                const json = await res.json();
                if (!res.ok) throw new Error("Failed to fetch brokerages");
                const list = Array.isArray(json?.data) ? json.data : [];
                const opts: Option[] = list
                    .map((b: any) => ({
                        value: String(
                            b?.organization_id ??
                                b?.value ??
                                b?.membership_id ??
                                b?.id ??
                                b?._id ??
                                ""
                        ).trim(),
                        label: String(
                            b?.company_name ??
                                b?.firmDetails?.companyName ??
                                b?.label ??
                                b?.text ??
                                b?.name ??
                                "(no name)"
                        ).trim(),
                        email: String(b?.email ?? "").trim(),
                        office_count: Number.isFinite(Number(b?.office_count))
                            ? Math.floor(Number(b?.office_count))
                            : 0,
                        profilePicURL: String(b?.profile_pic_url ?? b?.profilePicURL ?? "").trim(),
                    }))
                    .filter((o: Option) => o.value && o.label);
                setBrokerageOptions(opts);
            } catch {
                setBrokerageOptions([]);
            }
        })();
    }, [token, brokerageSearch, brokerageDropdownOpened, organizationId]);

    useEffect(() => {
        if (effectiveFirmId) setSelectedBrokerageId(effectiveFirmId);
    }, [effectiveFirmId]);

    // fetch roles
    useEffect(() => {
        (async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/roles`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const data = await res.json();
                if (!res.ok || data?.error) throw new Error(data?.error || "Failed to fetch roles");
                setRoles(Array.isArray(data) ? (data as Role[]) : []);
            } catch (e: any) {
                showError(e.message || "Failed to fetch roles");
            }
        })();
    }, [token]);

    // fetch member (edit)
    useEffect(() => {
        if (!isEdit) {
            setLoading(false);
            return;
        }
        (async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/users/${effectiveTeammemberId}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const data = (await res.json()) as TeamMemberAPI;
                if (!res.ok) throw new Error("Failed to load team member");
                setMember(data);

                // hydrate perm matrix from accessLevel
                const level = data.accessLevel || [];
                setPermState(prev => {
                    const next: PermState = { ...prev };
                    const allOn = level.includes("all");
                    Object.keys(next).forEach(k => {
                        next[k] = allOn
                            ? { create: true, view: true, edit: true, delete: true, all: true }
                            : {
                                create: false,
                                view: level.includes("view"),
                                edit: level.includes("edit"),
                                delete: level.includes("delete"),
                                all: false,
                            };
                    });
                    return next;
                });
            } catch (e: any) {
                showError(e.message || "Failed to load team member");
            } finally {
                setLoading(false);
            }
        })();
    }, [isEdit, effectiveTeammemberId, token]);

    // fetch assigned roles (edit mode)
    useEffect(() => {
        if (!isEdit || !effectiveTeammemberId) return;

        (async () => {
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/user-role-assignments/all-roles/${effectiveTeammemberId}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                const data = await res.json();
                if (!res.ok || data?.error) throw new Error(data?.error || "Failed to fetch assigned roles");
                const roleAssignments = Array.isArray(data) ? (data as RoleAssignment[]) : [];
                setAssignedRoles(roleAssignments);
                // Store the first assignment ID for updates
                if (roleAssignments.length > 0) {
                    setRoleAssignmentId(roleAssignments[0]._id);
                }
            } catch (e: any) {
                console.warn("Failed to fetch assigned roles:", e.message);
                setAssignedRoles([]);
            }
        })();
    }, [isEdit, effectiveTeammemberId, token]);

    const officeOptions: Option[] = useMemo(
        () => (offices ?? []).map(o => ({ value: o._id, label: o.officeName })),
        [offices]
    );

    const roleOptions: Option[] = useMemo(
        () => (roles ?? []).map(r => ({ value: r._id, label: r.name })),
        [roles]
    );

    const loadJobTitleOptions: LoadOptions<JobTitleOption, any, { page: number }> = useCallback(
        async (inputValue, _loadedOptions, additional) => {
            const page = additional?.page ?? 1;

            if (!token) {
                return {
                    options: [{ value: JOB_TITLE_CUSTOM, label: "Custom", id: JOB_TITLE_CUSTOM }],
                    hasMore: false,
                    additional: { page: 1 },
                };
            }

            try {
                const query = new URLSearchParams({
                    page: String(page),
                    limit: "10",
                });

                if (String(inputValue || "").trim()) {
                    query.set("search", String(inputValue).trim());
                }

                const response = await fetch(
                    `${process.env.REACT_APP_API_URL}/job-titles/select2?${query.toString()}`,
                    {
                        method: "GET",
                        headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                        },
                    }
                );

                const result = await response.json();
                if (!response.ok) {
                    throw new Error(result?.message || result?.error || "Failed to load job titles");
                }

                const apiOptions: JobTitleOption[] = Array.isArray(result?.results)
                    ? result.results
                        .filter((item: any) => item?.status !== false)
                        .map((item: any) => ({
                            value: String(item?.title || item?.text || item?.id || item?._id || ""),
                            label: String(item?.text || item?.title || ""),
                            id: String(item?.id || item?._id || ""),
                        }))
                        .filter((item: JobTitleOption) => item.value && item.label)
                    : [];

                const customOption: JobTitleOption = {
                    value: JOB_TITLE_CUSTOM,
                    label: "Custom",
                    id: JOB_TITLE_CUSTOM,
                };

                return {
                    options: [...apiOptions, customOption],
                    hasMore: page * 10 < Number(result?.total || 0),
                    additional: { page: page + 1 },
                };
            } catch (error) {
                console.warn("Failed to load job title options:", error);
                return {
                    options: [{ value: JOB_TITLE_CUSTOM, label: "Custom", id: JOB_TITLE_CUSTOM }],
                    hasMore: false,
                    additional: { page: page + 1 },
                };
            }
        },
        [token]
    );

    const DEFAULT_TEN_ZEROS = "0000000000";
    const withDefault = (v?: string, def = DEFAULT_TEN_ZEROS) =>
        !v || v.trim() === "" || v === def ? def : v;
    const toCoordinate = (value: unknown) => {
        const coordinate = Number(value ?? 0);
        return Number.isFinite(coordinate) ? coordinate : 0;
    };
    const US_COUNTRY_DEFAULTS = { country: "United States", countryCode: "US" } as const;

    const initialValues = useMemo<BrokerageTeammemberFormValues>(
        () => ({
            // personal
            firstName: member?.firstName || "",
            lastName: member?.lastName || "",
            phone: member?.phone1 || DEFAULT_TEN_ZEROS,
            secondaryPhone: member?.phone2 || "",
            // account (hidden while editing)
            email: member?.email || "",
            password: "",
            // profile/assignment
            jobTitle: member?.jobTitle || "",
            jobTitleId: member?.jobTitleId || member?.job_title_id || "",
            customRole: String(member?.customRole ?? (member as any)?.custom_role ?? "").trim(),
            assignedOffices: (member?.offices || []).map(o => o._id), // store ids in the form
            brokeragePermissions: assignedRoles.length > 0 ? assignedRoles[0].role_id : "", // Single role ID
            statuss: (member?.status && String(member.status).trim()) || "Active",
            image: null as File | null,
            profilePic: member?.profilePic || null,
        }),
        [member, assignedRoles]
    );

    const formik = useFormik<BrokerageTeammemberFormValues>({
        enableReinitialize: true,
        initialValues,
        validationSchema: Yup.object({
            firstName: firstNameValidation,
            lastName: lastNameValidation,
            phone: phoneValidation,
            email: isEdit ? Yup.string() : emailValidation,
            // password: isEdit ? Yup.string() : passwordValidation,
            jobTitle: Yup.string().required("Role is required"),
            jobTitleId: Yup.string().notRequired(),
            customRole: Yup.string().when("jobTitle", {
                is: JOB_TITLE_CUSTOM,
                then: (schema) =>
                    schema.trim().required("Custom role is required").min(1, "Enter the custom role"),
                otherwise: (schema) => schema.notRequired(),
            }),
            // assignedOffices: assignedOfficesValidation,
            // brokeragePermissions: Yup.string().required("Role & Permissions is required"),
            // statuss: statusValidation,
        }),
        onSubmit: async (values) => {
            try {
                setFormSubmitting(true);

                const profilePicPayload =
                    values.image instanceof File ? await fileToBase64(values.image) : undefined;
                const customJobTitle = String(values.customRole ?? "").trim();
                let resolvedJobTitle =
                    values.jobTitle === JOB_TITLE_CUSTOM && customJobTitle
                        ? customJobTitle
                        : values.jobTitle;
                let resolvedJobTitleId = String(values.jobTitleId || "").trim();

                if (values.jobTitle === JOB_TITLE_CUSTOM && customJobTitle) {
                    const createJobTitleResponse = await fetch(`${process.env.REACT_APP_API_URL}/job-titles`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${token}`,
                        },
                        body: JSON.stringify({
                            title: customJobTitle,
                            description: "",
                            status: true,
                        }),
                    });

                    const createJobTitleResult = await createJobTitleResponse.json();
                    if (!createJobTitleResponse.ok || createJobTitleResult?.error) {
                        throw new Error(createJobTitleResult?.message || createJobTitleResult?.error || "Failed to create job title");
                    }

                    resolvedJobTitle = String(createJobTitleResult?.title || customJobTitle);
                    resolvedJobTitleId = String(createJobTitleResult?.id || createJobTitleResult?._id || "").trim();
                }

                const scopeFirmId = String(selectedBrokerageId || effectiveFirmId || "").trim();
                // Brokerage selected → that org id (same as SignageBrokerageTeammembers create).
                const targetOrganizationId = scopeFirmId;
                const createdByName =
                    brokerageOptions.find((o) => o.value === scopeFirmId)?.label ||
                    "Brokerage Firm";
                const phone2 = String(values.secondaryPhone ?? "").trim();

                const firstOffice = (offices || []).find((o) =>
                    values.assignedOffices.includes(o._id)
                );
                const officeAddr = firstOffice?.officeAddress?.[0];
                const memberAddr = (member as { addresses?: { personal?: { address_details?: Record<string, unknown> } } })
                    ?.addresses?.personal?.address_details;
                const addrSource = (memberAddr || officeAddr || {}) as Record<string, unknown>;

                const payload: Record<string, unknown> = {
                    email: values.email,
                    password: isEdit ? values.password : "",
                    firstName: values.firstName,
                    lastName: values.lastName,
                    phone1: withDefault(values.phone) || values.phone,
                    phone2,
                    jobTitle: resolvedJobTitle,
                    ...(resolvedJobTitleId ? { jobTitleId: resolvedJobTitleId } : {}),
                    ...(profilePicPayload ? { profilePic: profilePicPayload } : {}),
                    status: (values.statuss || "Active").toUpperCase(),
                    userType: "team_member",
                    licenseType: "BROKERAGE_TEAM_MEMBER",
                    officeIDs: values.assignedOffices,
                    address: {
                        addressLine1: String(addrSource?.addressLine1 || ""),
                        addressLine2: String(addrSource?.addressLine2 || ""),
                        city: String(addrSource?.city || ""),
                        state: String(addrSource?.state || ""),
                        country: String(addrSource?.country || US_COUNTRY_DEFAULTS.country),
                        zip: String(addrSource?.zip || ""),
                        phone: withDefault(values.phone),
                        latitude: toCoordinate(addrSource?.latitude),
                        longitude: toCoordinate(addrSource?.longitude),
                        cityCode: String(addrSource?.cityCode || addrSource?.city || ""),
                        stateCode: String(addrSource?.stateCode || ""),
                        countryCode: String(addrSource?.countryCode || US_COUNTRY_DEFAULTS.countryCode),
                    },
                };

                if (allowExistingMemberAccessConfirm && confirmMemberAccessRef.current) {
                    payload.confirm_existing_brokerage_member_access = true;
                }
                confirmMemberAccessRef.current = false;

                if (!isEdit && !targetOrganizationId) {
                    throw new Error("Please select a brokerage firm");
                }

                const url = isEdit
                    ? `${process.env.REACT_APP_API_URL}/organization-memberships/${effectiveTeammemberId}`
                    : `${process.env.REACT_APP_API_URL}/organizations/${targetOrganizationId}/memberships/team-members`;
                const method = isEdit ? "PATCH" : "POST";

                const res = await fetch(url, {
                    method,
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(payload),
                });
                const json = await res.json();
                if (
                    allowExistingMemberAccessConfirm &&
                    (json?.code === "BROKERAGE_MEMBER_ACCESS_CONFIRMATION_REQUIRED" ||
                        json?.requires_confirmation === true)
                ) {
                    const existing = json?.existing_member || {};
                    setMemberAccessConfirmed(false);
                    setMemberAccessPrompt({
                        message:
                            json?.message ||
                            "A team member with this email already exists in the brokerage. Do you want to ask the brokerage to give your vendor access to this team member?",
                        name: String(existing?.name || "").trim(),
                        email: String(existing?.email || "").trim(),
                    });
                    return;
                }
                if (!res.ok || json?.error) throw new Error(json?.error || json?.message || "Failed to save");

                const chosenOffices = (offices || [])
                    .filter((o) => values.assignedOffices.includes(o._id))
                    .map((o) => ({ _id: o._id, officeName: o.officeName || "" }));

                const membership = json?.membership ?? json?.data?.membership ?? json?.data ?? json;
                const membershipId = String(
                    membership?._id ??
                        membership?.id ??
                        membership?.membership_id ??
                        json?.data?.id ??
                        json?.id ??
                        effectiveTeammemberId ??
                        ""
                ).trim();
                const globalUserId = String(
                    membership?.global_user_id ?? membership?.globalUserId ?? ""
                ).trim();
                const membershipOrgId = String(
                    membership?.organization_id ??
                        membership?.organizationId ??
                        (scopeFirmId || targetOrganizationId) ??
                        ""
                ).trim();
                // Prefer membership id for role assignment + project pick (foundation create response).
                const userId = membershipId;

                // Handle role assignment (single role)
                if (values.brokeragePermissions) {
                    if (isEdit) {
                        // Edit mode: Update existing role assignment using PATCH
                        if (roleAssignmentId) {
                            try {
                                const updateRes = await fetch(`${process.env.REACT_APP_API_URL}/user-role-assignments/${roleAssignmentId}`, {
                                    method: "PATCH",
                                    headers: {
                                        "Content-Type": "application/json",
                                        Authorization: `Bearer ${token}`,
                                    },
                                    body: JSON.stringify({
                                        user_id: userId,
                                        role_id: values.brokeragePermissions,
                                        scope_node_id: membershipOrgId || scopeFirmId,
                                        scope_node_type: "brokerage",
                                        can_delegate: false,
                                        is_default: false
                                    }),
                                });

                                if (!updateRes.ok) {
                                    const errorData = await updateRes.json();
                                    console.warn(`Failed to update role assignment ${roleAssignmentId}:`, errorData?.error || "Unknown error");
                                }
                            } catch (error) {
                                console.warn(`Error updating role assignment ${roleAssignmentId}:`, error);
                            }
                        }
                        else {
                            try {
                                const roleAssignmentRes = await fetch(`${process.env.REACT_APP_API_URL}/user-role-assignments`, {
                                    method: "POST",
                                    headers: {
                                        "Content-Type": "application/json",
                                        Authorization: `Bearer ${token}`,
                                    },
                                    body: JSON.stringify({
                                        user_id: userId,
                                        role_id: values.brokeragePermissions,
                                        scope_node_id: membershipOrgId || scopeFirmId,
                                        scope_node_type: "brokerage",
                                        can_delegate: false,
                                        is_default: false
                                    }),
                                });

                                if (roleAssignmentRes.ok) {
                                    const assignmentData = await roleAssignmentRes.json();
                                    // Store the assignment ID for future updates
                                    setRoleAssignmentId(assignmentData._id || assignmentData.data?._id);
                                } else {
                                    const errorData = await roleAssignmentRes.json();
                                    console.warn(`Failed to assign role ${values.brokeragePermissions}:`, errorData?.error || "Unknown error");
                                }
                            } catch (roleError) {
                                console.warn(`Error assigning role ${values.brokeragePermissions}:`, roleError);
                            }
                        }
                    } else {
                        // Create mode: Assign role to new user and store the assignment ID
                        try {
                            const roleAssignmentRes = await fetch(`${process.env.REACT_APP_API_URL}/user-role-assignments`, {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json",
                                    Authorization: `Bearer ${token}`,
                                },
                                body: JSON.stringify({
                                    user_id: userId,
                                    role_id: values.brokeragePermissions,
                                    scope_node_id: membershipOrgId || scopeFirmId,
                                    scope_node_type: "brokerage",
                                    can_delegate: false,
                                    is_default: false
                                }),
                            });

                            if (roleAssignmentRes.ok) {
                                const assignmentData = await roleAssignmentRes.json();
                                // Store the assignment ID for future updates
                                setRoleAssignmentId(assignmentData._id || assignmentData.data?._id);
                            } else {
                                const errorData = await roleAssignmentRes.json();
                                console.warn(`Failed to assign role ${values.brokeragePermissions}:`, errorData?.error || "Unknown error");
                            }
                        } catch (roleError) {
                            console.warn(`Error assigning role ${values.brokeragePermissions}:`, roleError);
                        }
                    }
                }

                showSuccess(isEdit ? "Team member updated successfully!" : "Team member created successfully!");
                if (onSuccess) {
                    if (!isEdit && userId) {
                        onSuccess({
                            id: String(userId),
                            membershipId: membershipId || String(userId),
                            globalUserId,
                            organizationId: membershipOrgId,
                            firstName: values.firstName,
                            lastName: values.lastName,
                            email: values.email,
                            phone: withDefault(values.phone) || values.phone,
                            brokerageFirmId: membershipOrgId || scopeFirmId,
                            brokerageFirmName: createdByName,
                            offices: chosenOffices,
                            jobTitle: resolvedJobTitle,
                        });
                    } else {
                        onSuccess();
                    }
                } else {
                    navigate(0);
                }
            } catch (e: any) {
                showError(e.message || "Failed to save team member");
            } finally {
                setFormSubmitting(false);
            }
        },
    });

    const closeMemberAccessPrompt = () => {
        if (formSubmitting) return;
        confirmMemberAccessRef.current = false;
        setMemberAccessConfirmed(false);
        setMemberAccessPrompt(null);
    };

    const confirmExistingMemberAccess = () => {
        if (!memberAccessConfirmed) {
            showError("Select the confirmation to continue.");
            return;
        }
        confirmMemberAccessRef.current = true;
        setMemberAccessPrompt(null);
        formik.handleSubmit();
    };

    // preview
    useEffect(() => {
        if (!formik.values.image) return setPreview(null);
        const url = URL.createObjectURL(formik.values.image);
        setPreview(url);
        return () => URL.revokeObjectURL(url);
    }, [formik.values.image]);

    const wrapperClassName =
        variant === "modal"
            ? "brokerage-teammember-creation-embedded"
            : variant === "inline"
              ? "brokerage-teammember-creation-inline"
              : "content container";

    if (loading) {
        return (
            <div className={variant === "standalone" ? "content" : "p-4"}>Loading...</div>
        );
    }

    // accordion helpers
    // 🔧 only CRUD keys are toggleable in state
    const toggleCell = (row: string, key: CrudKey) =>
        setPermState(prev => {
            const next = { ...prev };
            const curr: PermStateRow = {
                create: false, view: false, edit: false, delete: false, all: false,
                ...next[row],
            };

            // toggle
            curr[key] = !curr[key];

            // simple rules
            if (key === "all" && curr.all) {
                curr.create = curr.view = curr.edit = curr.delete = true;
            }
            // if ((["create","view","edit","delete"] as const).includes(key) && !curr[key]) {
            //   curr.all = false;
            // }

            next[row] = curr;
            return next;
        });

    const joinUrl = (base?: string, path?: string) => {
        if (!path) return "";
        if (!base) return path;
        if (/^https?:\/\//i.test(path)) return path;
        const b = base.replace(/\/+$/, "");
        const p = path.replace(/^\/+/, "");
        return `${b}/${p}`;
    };
    const displaySrc =
        preview ??
        serverImageSrc ??
        // last resort: try to build from a relative profilePic
        (typeof formik.values.profilePic === "string" && /^\/?uploads\//i.test(formik.values.profilePic)
            ? joinUrl(process.env.REACT_APP_BASE_URL, formik.values.profilePic)
            : null);

    return (
        <div className={wrapperClassName}>
            {/* <div className="">
                <h3 className="m-0 ">{isEdit ? "Edit Team Member" : "Add New Team Member"}</h3>
                <div className="text-muted mt-1" style={{ fontSize: 14 }}>
                    Create a new team member profile for your real estate team
                </div>
            </div> */}

            <form
                className="mb-5"
                autoComplete="off"
                onSubmit={(e) => {
                    e.preventDefault();
                }}
            >
                <div className="col-md-12" id="row-overlap">
                    <div className="d-none d-md-block">
                            <div className="mb-3">
                                {/* <div className="fw-semibold mb-2" style={{ fontSize: 20, color: "#111827" }}>
                                    Search Brokerage, Office, Agent, or Admin Name <span className="text-danger">*</span>
                                </div> */}
                                {/* <div className="d-flex align-items-start justify-content-between">
                                    <div>
                                        <h4 className="m-0">{isEdit ? "Edit Team Member" : "Add New Team Member"}</h4>
                                        <div className="text-muted mt-1" style={{ fontSize: 14 }}>
                                            Create a new team member profile for your real estate team
                                        </div>
                                    </div>
                                    <button
                                        type="button"
                                        className="btn p-0 border-0 bg-transparent text-muted me-3 close-btn br-8"
                                        aria-label="Close"
                                        onClick={handleCancel}
                                        style={{ fontSize: 24, lineHeight: 1 }}
                                    >
                                        ×
                                    </button>
                                </div> */}
                                {/* <div className="border-bottom mt-3" /> */}
                            </div>
                            <div className="row g-4">
                                {/* Brokerage */}
                                <div className="col-12">
                                    <div className="shadow-border-1 view-cards-shadow p-4 bg-white">
                                        <div className="align-items-center border-bottom d-flex pb-3">
                                            <IconHeading label="Brokerage" iconUrl={Permission_Assignment} color="#eef2ff" />
                                        </div>
                                        <div className="mt-3" style={{ maxWidth: 520 }}>
                                            <label className="form-label">
                                                Search and select a brokerage <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                classNamePrefix="rs"
                                                placeholder="Search brokerage name..."
                                                options={brokerageOptions}
                                                formatOptionLabel={(opt, meta) =>
                                                    renderBrokerageOptionLabelDesktop(opt as Option, meta as any)
                                                }
                                                filterOption={() => true}
                                                value={brokerageOptions.find((o: Option) => o.value === selectedBrokerageId) || null}
                                                onChange={(opt: SingleValue<Option>) => setSelectedBrokerageId(opt?.value || "")}
                                                onMenuOpen={() => setBrokerageDropdownOpened(true)}
                                                onInputChange={(val, action) => {
                                                    if (action.action === "input-change") setBrokerageSearchInput(val);
                                                    return val;
                                                }}
                                                onKeyDown={(e: any) => {
                                                    if (e?.key === "Enter") {
                                                        e.preventDefault();
                                                        setBrokerageSearch((brokerageSearchInput || "").trim());
                                                    }
                                                }}
                                                components={{ DropdownIndicator }}
                                                styles={brokerageSelectStylesDesktop as any}
                                                isSearchable
                                                isDisabled={!!effectiveFirmId}
                                                isClearable
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Personal Information */}
                                <div className="col-lg-6">
                                    <div className="shadow-border-1 view-cards-shadow p-4 bg-white">
                                        <div className="align-items-center border-bottom d-flex pb-3">
                                            <IconHeading label="Personal Information" iconUrl={Personal_Info} color="#F54A00" />
                                        </div>
                                        <div className="row g-3 mt-2">
                                            <div className="col-md-6">
                                                <label className="form-label">
                                                    First Name <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control br-8 ${formik.touched.firstName && formik.errors.firstName ? "is-invalid" : ""}`}
                                                    name="firstName"
                                                    value={formik.values.firstName}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    placeholder=""
                                                    {...noAutoSuggestInputProps}
                                                />
                                                {formik.touched.firstName && formik.errors.firstName && (
                                                    <div className="text-danger mt-1">{formik.errors.firstName as any}</div>
                                                )}
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label">
                                                    Last Name <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control br-8 ${formik.touched.lastName && formik.errors.lastName ? "is-invalid" : ""}`}
                                                    name="lastName"
                                                    value={formik.values.lastName}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    placeholder=""
                                                    {...noAutoSuggestInputProps}
                                                />
                                                {formik.touched.lastName && formik.errors.lastName && (
                                                    <div className="text-danger mt-1">{formik.errors.lastName as any}</div>
                                                )}
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label">
                                                    Phone <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control br-8 ${formik.touched.phone && formik.errors.phone ? "is-invalid" : ""}`}
                                                    name="phone"
                                                    value={formik.values.phone}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    placeholder=""
                                                    {...noAutoSuggestInputProps}
                                                />
                                                {formik.touched.phone && formik.errors.phone && (
                                                    <div className="text-danger mt-1">{formik.errors.phone as any}</div>
                                                )}
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label">Secondary Phone</label>
                                                <input
                                                    type="text"
                                                    className="form-control br-8"
                                                    name="secondaryPhone"
                                                    value={formik.values.secondaryPhone}
                                                    onChange={(e) =>
                                                        formik.setFieldValue("secondaryPhone", e.target.value)
                                                    }
                                                    onBlur={formik.handleBlur}
                                                    placeholder=""
                                                    {...noAutoSuggestInputProps}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="shadow-border-1 view-cards-shadow p-4 bg-white" style={{ height: "217px" }}>
                                        <div className="align-items-center border-bottom d-flex pb-3">
                                            <IconHeading label="Account Access" iconUrl={shield} color="#dcfce7" />

                                        </div>
                                        <div className="row g-3 mt-2">
                                            <div className="col-12">
                                                <label className="form-label">
                                                    Email <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="email"
                                                    id="brokerage-teammember-email-md"
                                                    name="email"
                                                    className={`form-control br-8 ${formik.touched.email && formik.errors.email ? "is-invalid" : ""}`}
                                                    value={formik.values.email}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    placeholder=""
                                                    disabled={isEdit}
                                                    {...noAutoSuggestInputProps}
                                                />
                                                {formik.touched.email && formik.errors.email && (
                                                    <div className="text-danger mt-1">{formik.errors.email as any}</div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Profile / Assignment */}
                            <div className="shadow-border-1 box-shadow-datatables view-cards-shadow p-4 bg-white mt-4">
                                <div className="align-items-center border-bottom d-flex pb-3">
                                    <IconHeading label="Profile" iconUrl={Profile} color="#155dfc" />
                                </div>

                                <div className="row g-4 align-items-end mt-2">
                                    {/* Upload tile */}
                                    <div className="col-md-3">
                                        <div className="form-label">Profile Image</div>
                                        <label
                                            htmlFor="image"
                                            className="d-inline-flex align-items-center justify-content-center mb-2"
                                            style={{
                                                width: 120,
                                                height: 120,
                                                border: "2px dashed #d0d5dd",
                                                borderRadius: 12,
                                                cursor: "pointer",
                                            }}
                                            title="Upload image"
                                        >
                                            {displaySrc ? (
                                                <img
                                                    src={displaySrc}
                                                    alt="Preview"
                                                    style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: 10 }}
                                                />
                                            ) : (
                                                <i className="bi bi-upload" />
                                            )}
                                        </label>
                                        <input
                                            id="image"
                                            name="image"
                                            type="file"
                                            accept="image/*"
                                            className="d-none"
                                            onChange={(e) => {
                                                const f = e.currentTarget.files?.[0] ?? null;
                                                formik.setFieldValue("image", f);
                                            }}
                                            onBlur={formik.handleBlur}
                                        />
                                        <div>
                                            <button
                                                type="button"
                                                className="btn upload-btn mt-2"
                                                onClick={() => document.getElementById("image")?.click()}
                                            >
                                                Upload Image
                                            </button>
                                            <div className="text-muted mt-2" style={{ fontSize: 12 }}>
                                                JPG, PNG up to 10MB
                                            </div>
                                        </div>
                                    </div>

                                    {/* Role */}
                                    <div className="col-md-3">
                                        <label className="form-label">
                                            Job Title / Role <span className="text-danger">*</span>
                                        </label>
                                        <AsyncPaginate
                                            classNamePrefix="rs"
                                            placeholder="Select job title / role"
                                            value={
                                                formik.values.jobTitle
                                                    ? {
                                                        value: formik.values.jobTitleId || formik.values.jobTitle,
                                                        label:
                                                            formik.values.jobTitle === JOB_TITLE_CUSTOM
                                                                ? "Custom"
                                                                : formik.values.jobTitle,
                                                    }
                                                    : null
                                            }
                                            loadOptions={loadJobTitleOptions}
                                            onChange={(selected) => {
                                                formik.setFieldValue("jobTitle", selected?.value || "");
                                                formik.setFieldValue("jobTitleId", selected?.id || selected?.value || "");
                                            }}
                                            onBlur={() => formik.setFieldTouched("jobTitle", true)}
                                            additional={{ page: 1 }}
                                            defaultOptions={false}
                                            loadOptionsOnMenuOpen
                                            debounceTimeout={300}
                                            isClearable
                                            components={{ DropdownIndicator }}
                                            styles={customSelectStyles}
                                        />
                                        {formik.touched.jobTitle && formik.errors.jobTitle && (
                                            <div className="text-danger mt-1">{formik.errors.jobTitle as any}</div>
                                        )}
                                    </div>
                                    {formik.values.jobTitle === JOB_TITLE_CUSTOM ? (
                                        <div className="col-md-3">
                                            <label className="form-label">
                                                Custom Role <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                className={`form-control br-8 ${formik.touched.customRole && formik.errors.customRole ? "is-invalid" : ""}`}
                                                name="customRole"
                                                value={formik.values.customRole}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                placeholder="Enter the custom role"
                                                {...noAutoSuggestInputProps}
                                            />
                                            {formik.touched.customRole && formik.errors.customRole && (
                                                <div className="text-danger mt-1">{formik.errors.customRole as any}</div>
                                            )}
                                        </div>
                                    ) : null}

                                    {/* Assign Offices (multi) */}
                                    <div className="col-md-3">
                                        <label className="form-label">Assign Offices</label>
                                        <Select
                                            isMulti
                                            options={officeOptions}
                                            value={officeOptions.filter(o => formik.values.assignedOffices.includes(o.value))}
                                            onChange={(opts) =>
                                                formik.setFieldValue(
                                                    "assignedOffices",
                                                    (opts || []).map((o: any) => o.value)
                                                )
                                            }
                                            onBlur={() => formik.setFieldTouched("assignedOffices", true)}
                                            placeholder="Select offices"
                                            classNamePrefix="rs"
                                            styles={customSelectStyles}
                                            components={{ DropdownIndicator }}
                                        />
                                        {formik.touched.assignedOffices && formik.errors.assignedOffices && (
                                            <div className="text-danger mt-1">{formik.errors.assignedOffices as any}</div>
                                        )}
                                    </div>

                                    {/* Status */}
                                    <div className="col-md-3">
                                        <label className="form-label">Status</label>
                                        <Select
                                            options={STATUS_OPTIONS}
                                            value={STATUS_OPTIONS.find(o => o.value === formik.values.statuss) || null}
                                            onChange={(opt) => formik.setFieldValue("statuss", opt?.value || "")}
                                            onBlur={() => formik.setFieldTouched("statuss", true)}
                                            placeholder="Select status"
                                            classNamePrefix="rs"
                                            styles={customSelectStyles}
                                            components={{ DropdownIndicator }}
                                        />
                                        {formik.touched.statuss && formik.errors.statuss && (
                                            <div className="text-danger mt-1">{formik.errors.statuss as any}</div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* --- local styles (keep in same file) --- */}
                            <style>{`
                                /* switcher: desktop table vs mobile cards */
                                .perm-desktop { display: none; }
                                .perm-mobile  { display: block; }
                                @media (min-width: 768px) {
                                  .perm-desktop { display: block; }
                                  .perm-mobile  { display: none; }
                                }

                                /* mobile card grid */
                                .perm-grid {
                                  display: grid;
                                  grid-template-columns: repeat(3, 1fr);
                                  gap: 12px 10px;
                                  align-items: center;
                                }
                                @media (max-width: 380px) {
                                  .perm-grid { grid-template-columns: repeat(2, 1fr); }
                                }
                                .perm-cell {
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                  gap: 6px;
                                  flex-direction: column;
                                  text-align: center;
                                }
                                .perm-checkbox { width: 20px; height: 20px; } /* larger tap target */
                                .close-btn{
                                padding: 8px 12px !important;
                                }
                                .close-btn:hover{
                                background-color: #f3f4f6 !important;
                                padding: 8px 12px !important;
                                }
                            `}</style>

                            {/* Footer */}
                            <div className="d-flex justify-content-end align-items-center mt-5">
                                <button type="button" className="btn back-btn surface-btn fw-bold fs-16 me-3" onClick={handleCancel}>
                                    Cancel
                                </button>
                                <button type="button" className="btn btn-primary save-btn surface-btn fw-bold fs-16" disabled={formSubmitting} onClick={() => formik.handleSubmit()}>
                                    {formSubmitting ? (isEdit ? "Saving..." : "Creating...") : isEdit ? "Save" : "Create Team Member"}
                                </button>
                            </div>
                    </div>
                    <div className="d-block d-md-none">
                        <div className="">
                            <div className="row g-4">
                                {/* Brokerage */}
                                <div className="col-12">
                                    <div className="shadow-border-1 box-shadow-datatables view-cards-shadow p-4 bg-white">
                                        <div className="align-items-center border-bottom d-flex pb-3">
                                            <IconHeading label="Brokerage" iconUrl={Permission_Assignment} color="#eef2ff" />
                                        </div>
                                        <div className="mt-3">
                                            <label className="form-label">
                                                Search and select a brokerage <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                classNamePrefix="rs"
                                                placeholder="Search brokerage name..."
                                                options={brokerageOptions}
                                                formatOptionLabel={(opt, meta) =>
                                                    renderBrokerageOptionLabelMobile(opt as Option, meta as any)
                                                }
                                                filterOption={() => true}
                                                value={brokerageOptions.find((o: Option) => o.value === selectedBrokerageId) || null}
                                                onChange={(opt: SingleValue<Option>) => setSelectedBrokerageId(opt?.value || "")}
                                                onMenuOpen={() => setBrokerageDropdownOpened(true)}
                                                onInputChange={(val, action) => {
                                                    if (action.action === "input-change") setBrokerageSearchInput(val);
                                                    return val;
                                                }}
                                                onKeyDown={(e: any) => {
                                                    if (e?.key === "Enter") {
                                                        e.preventDefault();
                                                        setBrokerageSearch((brokerageSearchInput || "").trim());
                                                    }
                                                }}
                                                components={{ DropdownIndicator }}
                                                styles={brokerageSelectStylesMobile as any}
                                                isSearchable
                                                isDisabled={!!effectiveFirmId}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {/* Personal Information */}
                                <div className="col-lg-6">
                                    <div className="shadow-border-1 box-shadow-datatables view-cards-shadow p-4 bg-white">
                                        <div className="d-flex align-items-center mb-5">
                                            <i className="bi bi-person-fill text-warning me-2" />
                                            <div className="fw-semibold">Personal Information</div>
                                        </div>
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <label className="form-label">
                                                    First Name <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control br-8 ${formik.touched.firstName && formik.errors.firstName ? "is-invalid" : ""}`}
                                                    name="firstName"
                                                    value={formik.values.firstName}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    placeholder=""
                                                    {...noAutoSuggestInputProps}
                                                />
                                                {formik.touched.firstName && formik.errors.firstName && (
                                                    <div className="text-danger mt-1">{formik.errors.firstName as any}</div>
                                                )}
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label">
                                                    Last Name <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control br-8 ${formik.touched.lastName && formik.errors.lastName ? "is-invalid" : ""}`}
                                                    name="lastName"
                                                    value={formik.values.lastName}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    placeholder=""
                                                    {...noAutoSuggestInputProps}
                                                />
                                                {formik.touched.lastName && formik.errors.lastName && (
                                                    <div className="text-danger mt-1">{formik.errors.lastName as any}</div>
                                                )}
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label">
                                                    Phone <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control br-8 ${formik.touched.phone && formik.errors.phone ? "is-invalid" : ""}`}
                                                    name="phone"
                                                    value={formik.values.phone}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    placeholder=""
                                                    {...noAutoSuggestInputProps}
                                                />
                                                {formik.touched.phone && formik.errors.phone && (
                                                    <div className="text-danger mt-1">{formik.errors.phone as any}</div>
                                                )}
                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label">Secondary Phone</label>
                                                <input
                                                    type="text"
                                                    className="form-control br-8"
                                                    name="secondaryPhone"
                                                    value={formik.values.secondaryPhone}
                                                    onChange={(e) =>
                                                        formik.setFieldValue("secondaryPhone", e.target.value)
                                                    }
                                                    onBlur={formik.handleBlur}
                                                    placeholder=""
                                                    {...noAutoSuggestInputProps}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <div className="shadow-border-1 box-shadow-datatables view-cards-shadow p-4 bg-white" style={{ height: "330px" }}>
                                        <div className="d-flex align-items-center mb-5">
                                            <i className="bi bi-shield-check text-success me-2" />
                                            <div className="fw-semibold">Account Access</div>
                                        </div>
                                        <div className="row g-3">
                                            <div className="col-12">
                                                <label className="form-label">
                                                    Email <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="email"
                                                    id="brokerage-teammember-email-xs"
                                                    name="email"
                                                    className={`form-control br-8 ${formik.touched.email && formik.errors.email ? "is-invalid" : ""}`}
                                                    value={formik.values.email}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    placeholder=""
                                                    disabled={isEdit}
                                                    {...noAutoSuggestInputProps}
                                                />
                                                {formik.touched.email && formik.errors.email && (
                                                    <div className="text-danger mt-1">{formik.errors.email as any}</div>
                                                )}
                                            </div>
                                            {/* <div className="col-12">
                                                <label className="form-label">
                                                    Password <span className="text-danger">*</span>
                                                </label>
                                                <div className="position-relative">
                                                    <input
                                                        type={showPassword ? "text" : "password"}
                                                        className={`form-control br-8 pe-5 ${formik.touched.password && formik.errors.password ? " is-invalid" : ""}`}
                                                        id="password"
                                                        name="password"
                                                        value={formik.values.password}
                                                        onChange={formik.handleChange}
                                                        onBlur={formik.handleBlur}
                                                        placeholder=""
                                                        disabled={isEdit}
                                                    />
                                                    <button
                                                        type="button"
                                                        className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted"
                                                        onClick={() => setShowPassword(!showPassword)}
                                                        style={{ border: "none", background: "none", padding: "8px" }}
                                                    >
                                                        <i className={showPassword ? "ri-eye-off-line fs-17" : "ri-eye-line fs-17"} />
                                                    </button>
                                                </div>
                                                {formik.touched.password && formik.errors.password && (
                                                    <div className="text-danger mt-1">{formik.errors.password as any}</div>
                                                )}
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Profile / Assignment */}
                            <div className="shadow-border-1 box-shadow-datatables view-cards-shadow p-4 bg-white mt-4">
                                <div className="d-flex align-items-center mb-5">
                                    <i className="bi bi-image text-primary me-2" />
                                    <div className="fw-semibold">Profile</div>
                                </div>

                                <div className="row g-4 align-items-end">
                                    {/* Upload tile */}
                                    <div className="col-md-2">
                                        <div className="form-label">Profile Image</div>
                                        <label
                                            htmlFor="image"
                                            className="d-inline-flex align-items-center justify-content-center mb-2"
                                            style={{
                                                width: 120,
                                                height: 120,
                                                border: "2px dashed #d0d5dd",
                                                borderRadius: 12,
                                                cursor: "pointer",
                                            }}
                                            title="Upload image"
                                        >
                                            {preview || formik.values.profilePic ? (
                                                <img
                                                    src={preview || `${process.env.REACT_APP_BASE_URL}${formik.values.profilePic}`}
                                                    alt="Preview"
                                                    style={{ width: "100%", height: "100%", objectFit: "contain", borderRadius: 10 }}
                                                />
                                            ) : (
                                                <i className="bi bi-upload" />
                                            )}
                                        </label>
                                        <input
                                            id="image"
                                            name="image"
                                            type="file"
                                            accept="image/*"
                                            className="d-none"
                                            onChange={(e) => {
                                                const f = e.currentTarget.files?.[0] ?? null;
                                                formik.setFieldValue("image", f);
                                            }}
                                            onBlur={formik.handleBlur}
                                        />
                                        <div>
                                            <button
                                                type="button"
                                                className="btn upload-btn mt-2"
                                                onClick={() => document.getElementById("image")?.click()}
                                            >
                                                Upload Image
                                            </button>
                                            <div className="text-muted mt-2" style={{ fontSize: 12 }}>
                                                JPG, PNG up to 10MB
                                            </div>
                                        </div>
                                    </div>

                                    {/* Role */}
                                    <div className="col-md-2">
                                        <label className="form-label">
                                            Job Title / Role <span className="text-danger">*</span>
                                        </label>
                                        <AsyncPaginate
                                            classNamePrefix="rs"
                                            placeholder="Select job title / role"
                                            value={
                                                formik.values.jobTitle
                                                    ? {
                                                        value: formik.values.jobTitleId || formik.values.jobTitle,
                                                        label:
                                                            formik.values.jobTitle === JOB_TITLE_CUSTOM
                                                                ? "Custom"
                                                                : formik.values.jobTitle,
                                                    }
                                                    : null
                                            }
                                            loadOptions={loadJobTitleOptions}
                                            onChange={(selected) => {
                                                formik.setFieldValue("jobTitle", selected?.value || "");
                                                formik.setFieldValue("jobTitleId", selected?.id || selected?.value || "");
                                            }}
                                            onBlur={() => formik.setFieldTouched("jobTitle", true)}
                                            additional={{ page: 1 }}
                                            defaultOptions={false}
                                            loadOptionsOnMenuOpen
                                            debounceTimeout={300}
                                            isClearable
                                            components={{ DropdownIndicator }}
                                            styles={customSelectStyles}
                                        />
                                        {formik.touched.jobTitle && formik.errors.jobTitle && (
                                            <div className="text-danger mt-1">{formik.errors.jobTitle as any}</div>
                                        )}
                                    </div>
                                    {formik.values.jobTitle === JOB_TITLE_CUSTOM ? (
                                        <div className="col-md-2">
                                            <label className="form-label">
                                                Custom Role <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="text"
                                                id="customRole-mobile"
                                                name="customRole"
                                                className={`form-control br-8 ${formik.touched.customRole && formik.errors.customRole ? "is-invalid" : ""}`}
                                                value={formik.values.customRole}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                placeholder="Enter the custom role"
                                                {...noAutoSuggestInputProps}
                                            />
                                            {formik.touched.customRole && formik.errors.customRole && (
                                                <div className="text-danger mt-1">{formik.errors.customRole as any}</div>
                                            )}
                                        </div>
                                    ) : null}

                                    {/* Assign Offices (multi) */}
                                    <div className="col-md-3">
                                        <label className="form-label">
                                            Assign Offices <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                            isMulti
                                            options={officeOptions}
                                            value={officeOptions.filter(o => formik.values.assignedOffices.includes(o.value))}
                                            onChange={(opts) =>
                                                formik.setFieldValue(
                                                    "assignedOffices",
                                                    (opts || []).map((o: any) => o.value)
                                                )
                                            }
                                            onBlur={() => formik.setFieldTouched("assignedOffices", true)}
                                            placeholder="Select offices"
                                            classNamePrefix="rs"
                                            styles={customSelectStyles}
                                            components={{ DropdownIndicator }}
                                        />
                                        {formik.touched.assignedOffices && formik.errors.assignedOffices && (
                                            <div className="text-danger mt-1">{formik.errors.assignedOffices as any}</div>
                                        )}
                                    </div>

                                    {/* Role & Permissions */}
                                    <div className="col-md-3 mb-3">
                                        <label className="form-label">
                                            Role & Permissions <span className="text-danger">*</span>
                                        </label>
                                        <Select
                                            options={roleOptions}
                                            value={roleOptions.find(o => o.value === formik.values.brokeragePermissions) || null}
                                            onChange={(opt) => formik.setFieldValue("brokeragePermissions", opt?.value || "")}
                                            onBlur={() => formik.setFieldTouched("brokeragePermissions", true)}
                                            placeholder="Choose role/permission"
                                            classNamePrefix="rs"
                                            styles={customSelectStyles}
                                            components={{ DropdownIndicator }}
                                        />
                                        {formik.touched.brokeragePermissions && formik.errors.brokeragePermissions && (
                                            <div className="text-danger mt-1">{formik.errors.brokeragePermissions as any}</div>
                                        )}
                                    </div>

                                    {/* Status */}
                                    <div className="col-md-2">
                                        <label className="form-label">Status</label>
                                        <Select
                                            options={STATUS_OPTIONS}
                                            value={STATUS_OPTIONS.find(o => o.value === formik.values.statuss) || null}
                                            onChange={(opt) => formik.setFieldValue("statuss", opt?.value || "")}
                                            onBlur={() => formik.setFieldTouched("statuss", true)}
                                            placeholder="Select status"
                                            classNamePrefix="rs"
                                            styles={customSelectStyles}
                                            components={{ DropdownIndicator }}
                                        />
                                        {formik.touched.statuss && formik.errors.statuss && (
                                            <div className="text-danger mt-1">{formik.errors.statuss as any}</div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* --- local styles (keep in same file) --- */}
                            <style>{`
                                /* switcher: desktop table vs mobile cards */
                                .perm-desktop { display: none; }
                                .perm-mobile  { display: block; }
                                @media (min-width: 768px) {
                                  .perm-desktop { display: block; }
                                  .perm-mobile  { display: none; }
                                }

                                /* mobile card grid */
                                .perm-grid {
                                  display: grid;
                                  grid-template-columns: repeat(3, 1fr);
                                  gap: 12px 10px;
                                  align-items: center;
                                }
                                @media (max-width: 380px) {
                                  .perm-grid { grid-template-columns: repeat(2, 1fr); }
                                }
                                .perm-cell {
                                  display: flex;
                                  align-items: center;
                                  justify-content: center;
                                  gap: 6px;
                                  flex-direction: column;
                                  text-align: center;
                                }
                                .perm-checkbox { width: 20px; height: 20px; } /* larger tap target */
                            `}</style>

                            {/* Footer */}
                            <div className="d-flex justify-content-end align-items-center mt-5">
                                <button type="button" className="btn btn-primary save-btn surface-btn fw-bold fs-16 me-3" disabled={formSubmitting} onClick={() => formik.handleSubmit()}>
                                    {formSubmitting ? (isEdit ? "Saving..." : "Creating...") : isEdit ? "Save" : "Create Team Member"}
                                </button>
                                <button type="button" className="btn back-btn surface-btn fw-bold fs-16" onClick={handleCancel}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            {memberAccessPrompt ? (
                <div
                    className="modal fade show d-block"
                    style={{ backgroundColor: "rgba(0,0,0,0.45)", zIndex: 2000 }}
                    onClick={closeMemberAccessPrompt}
                >
                    <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content border-0 shadow roboto-new" style={{ borderRadius: 16 }}>
                            <div className="modal-header border-0 pb-0">
                                <h5 className="modal-title fs-19 mb-0">Existing team member</h5>
                                <button type="button" className="btn-close" disabled={formSubmitting} onClick={closeMemberAccessPrompt} />
                            </div>
                            <div className="modal-body pt-3">
                                <p className="mb-3" style={{ color: "#4b5563", fontWeight: 400, fontSize: 15 }}>{memberAccessPrompt.message}</p>
                                {memberAccessPrompt.name || memberAccessPrompt.email ? (
                                    <div className="mb-3">
                                        <label className="form-label mb-2">User Name</label>
                                        <div style={{ border: "1px solid #e5e7eb", background: "#fff", borderRadius: 12, padding: "12px 14px" }}>
                                            {memberAccessPrompt.name ? <div style={{ fontSize: 15, fontWeight: 500, color: "#101828" }}>{memberAccessPrompt.name}</div> : null}
                                            {memberAccessPrompt.email ? <div style={{ fontSize: 14, fontWeight: 400, color: "#667085" }}>{memberAccessPrompt.email}</div> : null}
                                        </div>
                                    </div>
                                ) : null}
                                <button
                                    type="button"
                                    className="w-100 text-start"
                                    onClick={() => setMemberAccessConfirmed(true)}
                                    style={{
                                        border: memberAccessConfirmed ? "1px solid #155dfc" : "1px solid #e5e7eb",
                                        background: memberAccessConfirmed ? "#eff6ff" : "#fff",
                                        color: memberAccessConfirmed ? "#155dfc" : "#101828",
                                        borderRadius: 12,
                                        padding: "12px 14px",
                                        fontFamily: "Roboto, sans-serif",
                                        fontSize: 15,
                                        fontWeight: 500,
                                    }}
                                >
                                    <span
                                        className="d-inline-flex align-items-center justify-content-center me-2"
                                        style={{
                                            width: 16,
                                            height: 16,
                                            borderRadius: "50%",
                                            border: `2px solid ${memberAccessConfirmed ? "#155dfc" : "#d0d5dd"}`,
                                            verticalAlign: "middle",
                                        }}
                                    >
                                        {memberAccessConfirmed ? <span style={{ width: 8, height: 8, borderRadius: "50%", background: "#155dfc" }} /> : null}
                                    </span>
                                    Ask the brokerage to give access to this team member
                                </button>
                            </div>
                            <div className="modal-footer border-0 pt-0">
                                <button type="button" className="btn back-btn surface-btn fw-bold fs-16" disabled={formSubmitting} onClick={closeMemberAccessPrompt}>
                                    Cancel
                                </button>
                                <button type="button" className="btn btn-primary save-btn surface-btn fw-bold fs-16" disabled={formSubmitting} onClick={confirmExistingMemberAccess}>
                                    {formSubmitting ? "Saving..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
        </div>
    );
}
